const de = {
  "nav.search": "Suchen...",
  "nav.moreOptions": "Weitere Optionen",
  "nav.hide": "Ausblenden",
  "nav.show": "Anzeigen",
  "nav.logout": "Abmelden",
  "nav.language": "Sprache",
  "nav.dashboard": "Dashboard",
  "nav.inbox": "Nachrichten",
  "nav.crm": "CRM",
  "nav.agenda": "Kalender",
  "nav.business": "Mein Betrieb",
  "nav.admin": "Verwaltung",
  "nav.email": "E-Mail",
  "nav.whatsapp": "WhatsApp",
  "nav.marketing": "Marketing",
  "nav.plan": "Mein Plan",
  "nav.integrations": "Integrationen",
  "nav.setup": "Auto-Betreuung",
  "nav.ai": "KI-Einstellungen",
  "nav.reports": "Berichte",
  "nav.social": "Social & Ads",
  "nav.web": "Webseite",
  "mkt.title": "Marketing",
  "mkt.sub": "Akquise und Wachstum. Massen-E-Mail und WhatsApp finden Sie im Seitenmenü.",
  "mkt.home": "Start",
  "mkt.origins": "Lead-Quellen",
  "mkt.lists": "Listen",
  "mkt.automations": "Sequenzen",
  "mkt.more": "Mehr",
  "mkt.campaigns": "Kampagnen (erweitert)",
  "mkt.contacts": "Kontakte",
  "mkt.schedules": "Versandkalender",
  "mkt.delivery": "Versandtests",
  "mkt.whatToday": "Was möchten Sie heute tun?",
  "mkt.whatTodaySub": "Hier ist die Akquise (QR, Listen, Automatisierungen). Massen-Mailing oder WhatsApp im Seitenmenü.",
  "mkt.originsTitle": "Lead-Quellen",
  "mkt.originsSub": "WhatsApp per Phrase, QR, Portale, Web…",
  "mkt.originsP1": "QR mit Startnachricht erstellen",
  "mkt.originsP2": "Der Lead schreibt und kommt in Ihren Flow / KI",
  "mkt.originsP3": "In Sekunden herunterladen und drucken",
  "mkt.originsCta": "Quellen konfigurieren",
  "mkt.audienceTitle": "Listen und Zielgruppen",
  "mkt.audienceSub": "Wen Sie bei jedem Versand ansprechen",
  "mkt.audienceP1": "Landing oder Formular mit CRM verbunden",
  "mkt.audienceP2": "Startet Flows und Zuweisung",
  "mkt.audienceP3": "Ideal für digitale Kampagnen",
  "mkt.audienceCta": "Quellen ansehen",
  "mkt.segmentsTitle": "Listen / Segmente",
  "mkt.segmentsText": "Wen Sie anschreiben (Geburtstage, CRM-Phase, Daten…)",
  "mkt.autoTitle": "Nurturing-Sequenzen",
  "mkt.nurtureHint": "So pflegen Sie Leads automatisch per E-Mail und WhatsApp.",
  "mkt.autoText": "Willkommen, Termine, Geburtstage, Reaktivierung und mehr.",
  "mkt.massSection": "Massenversand (eigene Module)",
  "mkt.emailMass": "Massen-E-Mail",
  "mkt.emailMassSub": "SES-Mailing · Vorlagen · Berichte",
  "mkt.waMass": "Massen-WhatsApp",
  "mkt.waMassSub": "Meta-Vorlagen · Versand · API-Verbindung",
  "mkt.statLeads": "Leads",
  "mkt.statTpl": "WA-Vorlagen",
  "mkt.statDrafts": "Kampagnen-Entwürfe",
  "mkt.statAuto": "Aktive Automatisierungen",
  "email.home": "Start",
  "email.new": "Neuer Versand",
  "email.history": "Verlauf",
  "email.templates": "Vorlagen",
  "email.domain": "Meine Domain",
  "email.reports": "Berichte",
  "email.title": "E-Mail",
  "email.sub": "Massen-E-Mail unter Ihrer Marke",
  "wa.home": "Start",
  "wa.connection": "Verbindung",
  "wa.sends": "Versand",
  "wa.templates": "Vorlagen",
  "wa.reports": "Berichte",
  "wa.title": "WhatsApp",
  "wa.sub": "Massenversand und Business-API",
  "crm.pipeline": "Pipeline",
  "crm.leads": "Leads",
  "crm.tasks": "Aufgaben",
  "crm.templates": "Vorlagen",
  "inbox.all": "Alle",
  "inbox.open": "Offen",
  "inbox.closed": "Geschlossen",
  "agenda.calendar": "Kalender",
  "agenda.resources": "Dienste und Ressourcen",
  "agenda.tables": "Tischplan",
  "biz.summary": "Mein Betrieb",
  "biz.team": "Mein Team",
  "biz.assignment": "Zuweisung",
  "biz.flows": "Flow-Builder",
  "biz.profile": "Profil und Zeiten",
  "biz.locations": "Standorte",
  "rep.status": "Status",
  "rep.detail": "Technische Details",
  "common.loading": "Laden…",
  "common.cancel": "Abbrechen",
  "common.save": "Speichern",
  "common.next": "Weiter",
  "common.back": "Zurück",
  "common.edit": "Bearbeiten",
  "common.delete": "Löschen",
  "common.create": "Erstellen",
  "common.view": "Ansehen",
  "common.close": "Schließen",
  "common.copy": "Kopieren",
  "common.search": "Suchen",
  "common.active": "Aktiv",
  "common.inactive": "Inaktiv",
  "origins.title": "Lead-Quellen",
  "origins.sub": "Eine Quelle = Medium + Eingang + Kampagne. WhatsApp, Anruf, Webhook oder intelligente E-Mail.",
  "origins.create": "Quelle erstellen",
  "origins.edit": "Bearbeiten",
  "origins.connection": "Verbindungsdaten",
  "origins.webhook": "Webhook",
  "origins.email": "Intelligente E-Mail",
  "origins.secret": "Secret",
  "origins.secretOnce": "Secret (jetzt kopieren; voller Wert nur einmal sichtbar)",
  "origins.regen": "Secret neu erzeugen",
  "origins.copy": "Kopieren",
  "origins.free": "Freie WhatsApp-Nachrichten",
  "origins.freeHelp": "Immer aktiv. Chats ohne Kampagnenphrase oder wenn der Lead den Text löscht.",
  "origins.empty": "Noch keine Quellen",
  "origins.leads": "Leads",
  "origins.save": "Änderungen speichern",
  "origins.close": "Schließen",
  "origins.howTo": "So verbinden",
  "lang.es": "Español",
  "lang.en": "English",
  "lang.de": "Deutsch",
  "lang.pt": "Português",
  "lang.choose": "Sprache",
  "lang.auto": "Automatisch (nach Region)",
  "login.title": "Anmelden",
  "login.subtitle": "Zugang zu Ihrem Unternehmen",
  "login.email": "E-Mail",
  "login.password": "Passwort",
  "login.name": "Name",
  "login.submit": "Anmelden",
  "login.register": "Konto erstellen",
  "login.haveAccount": "Bereits ein Konto? Anmelden",
  "login.noAccount": "Noch kein Konto? Registrieren",
  "login.forgot": "Passwort vergessen?",
  "login.mfa": "Zwei-Faktor-Authentifizierung",
  "login.mfaHint": "Geben Sie den 6-stelligen Code aus Ihrer Authenticator-App oder einen Backup-Code ein.",
  "login.code": "Code",
  "login.inactive": "Ihre Sitzung endete nach 60 Minuten Inaktivität.",
  "login.titleRegister": "Konto erstellen",
  "login.titleLogin": "Anmelden",
  "login.emailLabel": "E-Mail",
  "login.passwordLabel": "Passwort",
  "login.nameLabel": "Vollständiger Name",
  "login.submitLogin": "Anmelden",
  "login.submitRegister": "Konto erstellen",
  "login.switchToLogin": "Bereits ein Konto? Anmelden",
  "login.switchToRegister": "Noch kein Konto? Registrieren",
  "login.heroTitle": "Ihr Unternehmen, automatisiert",
  "login.heroSub": "Betreuung, Verkauf und Nachverfolgung an einem Ort.",
  "login.verify": "Bestätigen",
  "dash.welcome": "Willkommen",
  "dash.overview": "Überblick über Ihren Betrieb",
  "admin.pos": "Kasse",
  "admin.warranty": "Service-Schalter",
  "admin.condo": "Hausverwaltung",
  "admin.sub": "Betriebsablauf: Kasse und POS",
  "filtros.from": "Von",
  "filtros.to": "Bis",
  "filtros.seller": "Verkäufer",
  "filtros.group": "Gruppe",
  "filtros.campaign": "Kampagne",
  "filtros.clear": "Filter löschen",
  "common.all": "Alle",
  "common.all_f": "Alle",
};
export default de;
